export default {"src":"/_next/static/media/paramount.01760b3e.svg","height":24,"width":89,"blurWidth":0,"blurHeight":0};